import { DEST_I18N } from "./contentTranslations";

// Return a Destinations stack item with title/sub localized for `lang`.
export function locStack(item, lang) {
  const o = lang && lang !== "de" && DEST_I18N[lang] && DEST_I18N[lang][item.img];
  return o ? { ...item, ...o } : item;
}
